/** @jsx jsx */
import React, { useMemo } from 'react';
import { jsx } from '@emotion/core';
import { getPositionAbsoluteStyles, getPositionFixedStyles, getPositionRelativeStyles } from '../styles/modal';

const Positioner = function Positioner({
  scrollBehavior,
  stackIndex,
  children,
  testId
}) {
  const positionerStyles = useMemo(() => {
    switch (scrollBehavior) {
      case 'outside':
        return getPositionRelativeStyles(stackIndex);

      case 'inside-wide':
        return getPositionFixedStyles(stackIndex);

      default:
        return getPositionAbsoluteStyles(stackIndex);
    }
  }, [scrollBehavior, stackIndex]);
  return jsx("div", {
    css: positionerStyles,
    "data-testid": testId && `${testId}--positioner`
  }, children);
};

Positioner.displayName = 'Positioner';
export default Positioner;